import React from 'react'
import { CustomSnackbarContext } from './context'

export const useCustomSnackbar = (): [string, (value: string) => void | string] => {
  const { snackbarMessage, setSnackbarMessage } = React.useContext(
    CustomSnackbarContext
  )

  return [snackbarMessage, setSnackbarMessage]
}
